import { EmployeeController, WalletController } from '../../controllers';
import { appStore, employeeStore, userStore } from '../../stores';
import { MimaToastUtil } from '../../components';
import { object, string, number } from 'yup';
import constant from '../../utils/constant';
import { AddLoan } from '../../pages';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const AddLoanContainer = ({ closeModal, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.EMPLOYEEADDEMPLOYEELOAN);

	const goBack = () => {
		closeModal();
	};
	const validationSchema = () => {
		return object({
			employee: string().required('Select an Employee'),
			amountCollected: number().required('Disbursement Amount is required').min(1),
			rePaymentMonths: number().required('Repayment Cycle is Required').min(1),
			disbursementDate: string().required('Date of Disbursement is required'),
			dateOfFirstRePayment: string().required(' date of First Repayment is required'),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);

		delete payload.employeeName

		const { status, errorMessage } = await EmployeeController.applyLoan(
			payload
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<AddLoan
			loading={loading}
			onSubmit={onSubmit}
			closeModal={closeModal}
			validationSchema={validationSchema}
			goBack={goBack}
		/>
	);
};

export default observer(AddLoanContainer);
